/* eslint-disable @typescript-eslint/ban-types */
import { FormControl } from '@material-ui/core'
import { renderErrorInField } from '@flatsy/utils/Functions/form/Helpers'
import React from 'react'
import TextField from '@material-ui/core/TextField'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { isValid } from 'date-fns'
import { useStyles } from './Style'
import { SingleFieldProps } from '../../../../Types'

const DateField = <T extends {}>({
  field,
  meta,
  input,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const date = format(new Date(), 'yyyy-MM-dd')

  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (field.changeEvent && isValid(val.target.value)) {
      field.changeEvent(val.target.value)
    }
  }

  return (
    <FormControl
      component="fieldset"
      error={renderErrorInField(meta)}
      name={field.name}
      key={field.name}
      className={classes.container}
    >
      <TextField
        type="date"
        onChange={onChange}
        defaultValue={date}
        className={classes.date}
        InputLabelProps={{
          shrink: true,
        }}
        value={input.value || undefined}
      />
    </FormControl>
  )
}

export default DateField
